// import getCookie from "../utils/getCookie";

export default class {
	static async ajaxCall(url, type, data, context) {
		let body;
		let error;
		const dataType = 'json';

		try {
			body = await $.ajax({
				context,
				url,
				type,
				data: data ? JSON.stringify(data) : null,
				dataType,
				contentType: "application/json; charset=UTF-8",
				beforeSend: (xhr) => {
					if (type === 'post' || type === 'patch' || type === 'delete') {
						xhr.setRequestHeader('X-CSRFToken', $("[name=csrfmiddlewaretoken]").val());
					}
				}
			});
		} catch (e) {
			error = e;
		}

		return {
			body,
			error
		}
	}

	static async addSubContractor(data, context) {
		const url = `/api/job-sub-contractors/`;
		return await this.ajaxCall(url, 'post', data, context);
	}

	static async removeSubContractor(id, context) {
		const url = `/api/job-sub-contractors/${id}/`;
		return await this.ajaxCall(url, 'delete', null, context);
	}

	static async getSubContractorsForJob(jobId, context) {
		const url = `/api/job-sub-contractors/?job_id=${jobId}`;
		return await this.ajaxCall(url, 'get', '', context);
	}

	static async getSubContractorsByName(name, date_required=false, context) {
		let url = `/api/sub-contractors/?s=${name}`;

		if (date_required) {
			url += `&date_required=${date_required}`;
		}

		return await this.ajaxCall(url, 'get', '', context);
	}


	static async sendJob(listToSend, context) {
		const url = `/api/job-sub-contractors/`;
		const data = [];

		listToSend.forEach(id => {
			data.push({
				id: parseInt(id),
				'sent': true
			})
		});
		return await this.ajaxCall(url, 'patch', data, context);
	}

	static async updateRego(id, newRego, context) {
		const url = `/api/job-sub-contractors/${parseInt(id)}/update-rego/`;
		const data = {
			registered_vehicle: newRego
		}
		return await this.ajaxCall(url, 'patch', data, context);

	}

	static async sendMessage(listToSend, message, jobId, context) {
		const url = jobId ? `/api/job-send-message/` : `api/sub-contractors/send-message/`;

		const subContractors = [];

		listToSend.forEach(item => {
			subContractors.push(parseInt(item.id))
		});

		const data = {
			sub_contractors: subContractors,
			message
		};

		if (jobId) {
			data['job_id'] = parseInt(jobId)
		}

		return await this.ajaxCall(url, 'post', data, context);
	}

	static async sendJobDockets(sendTo, message, jobId, context) {
		const url = `/api/job/${jobId}/email-dockets/`

		const data = {
			emails: sendTo,
			message
		};

		return await this.ajaxCall(url, 'post', data, context);
	}

	static async getJobHistory(jobId, context) {
		const url = `/api/job-history/?job_id=${jobId}`;
		return await this.ajaxCall(url, 'get', '', context);
	}

	static async setJobReminders(jobId, value, context) {
		const url = `/api/job/${jobId}/`;
		return await this.ajaxCall(url, 'patch', {send_docket_reminders: value}, context);
	}

	static async setJobDraft(jobId, value, context) {
		const url = `/api/job/${jobId}/`;
		return await this.ajaxCall(url, 'patch', {is_draft: value}, context);
	}

	static async toggleDriverReminders(id, value, context) {
		const url = `/api/job-sub-contractors/${id}/`;
		const data = {
			respond_to_job_reminders: value
		}
		return await this.ajaxCall(url, 'patch', data, context);
	}

	static async toggleAdminNotifications(id, value, context) {
		const url = `/api/job-sub-contractors/${id}/`;
		const data = {
			docket_notifications: value
		}
		return await this.ajaxCall(url, 'patch', data, context);
	}

	static async updateJobOrder(context) {
		const url = '/api/job/bulk/';
		const jobs = $('#jobs .job');
		const data = [];

		jobs.each((index, element) => {
			data.push({
				id: $(element).data('job-id'),
				order_priority: index
			});
		});

		return await this.ajaxCall(url, 'patch', data, context);
	}

	static async deleteTipping(tippingId, context) {
		const url = `/api/job/tipping/delete/${tippingId}/`;
		return await this.ajaxCall(url, 'delete', null, context);
	}
}